import React from "react";
import PropTypes from "prop-types";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import classes from "./Images45.module.scss";
import { InputLabel } from "../../../../../../../shared/InputLabel/InputLabel";
import { ImageUploader } from "../../../../../../../boxes/ImageUploader/ImageUploader";
import {
  IMAGE_COMPRESS_WIDTH,
  IMAGE_UPLOAD_TYPE,
} from "../../CosmeticCreateEdit.consts";
import { useDefaultImage } from "../../hooks/useDefaultImage";
import { Skeleton } from "../../../../../../../shared/Skeleton/Skeleton";
import { PROCEDURE_AREA } from "../Info/Info.consts";
import { useImageUploader } from "../../../../../../../hooks/useImageUploader";
import { uiNotification } from "../../../../../../../services/UINotificationService";

export function Images45({
  procedureImage,
  leftImage,
  rightImage,
  isLoading,
  procedureArea,
  onUploadingChange,
  onLeftUploadSuccess,
  onRightUploadSuccess,
  isImagesUploading,
}) {
  const { tClients } = useAppTranslation.Clients();
  const defaultImage = useDefaultImage();

  const uploader = useImageUploader({
    distinguishByName: true,
    uploadType: IMAGE_UPLOAD_TYPE,
    onLoadingChange: onUploadingChange,
    compress: {
      width: IMAGE_COMPRESS_WIDTH,
    },
  });

  const upload = async (e) => {
    if (isImagesUploading) {
      uiNotification.warn(
        tClients("createEditCosmeticProcedure.warn.uploadingImages"),
      );
      return Promise.reject();
    }
    return uploader.htmlOnChange(e);
  };

  return (
    <div>
      <div className={classes.title}>
        {tClients("createEditCosmeticProcedure.images.45degrees")}
      </div>
      {isLoading ? (
        <div className={classes.images}>
          {Array.from(Array(3).keys()).map((i) => (
            <Skeleton
              key={i}
              count={1}
              height={137}
              width="122px"
              borderRadius="4px"
            />
          ))}
        </div>
      ) : (
        <div className={classes.images}>
          {procedureArea !== PROCEDURE_AREA.laser &&
            procedureArea !== PROCEDURE_AREA.coolSculpting && (
              <div>
                <InputLabel>
                  {tClients("createEditCosmeticProcedure.images.procedure")}
                </InputLabel>
                <ImageUploader
                  name="procedureImage45"
                  value={procedureImage.value}
                  isLoading={
                    uploader.isLoading &&
                    uploader.uploadingName === "procedureImage45"
                  }
                  onChange={(e) =>
                    upload(e).then((res) => {
                      procedureImage.onChange(res?.uploadedFileFullPath);
                    })
                  }
                  onRemove={() => procedureImage.onChange(null)}
                  defaultImage={defaultImage}
                />
              </div>
            )}
          <div>
            <InputLabel>
              {tClients("createEditCosmeticProcedure.images.left")}
            </InputLabel>
            <ImageUploader
              name="leftImage45"
              value={leftImage.value}
              isLoading={
                uploader.isLoading && uploader.uploadingName === "leftImage45"
              }
              onChange={(e) =>
                upload(e).then((res) => {
                  leftImage.onChange(res?.uploadedFileFullPath);
                  onLeftUploadSuccess();
                })
              }
              onRemove={() => leftImage.onChange(null)}
              defaultImage={defaultImage}
            />
          </div>
          <div>
            <InputLabel>
              {tClients("createEditCosmeticProcedure.images.right")}
            </InputLabel>
            <ImageUploader
              name="rightImage45"
              value={rightImage.value}
              isLoading={
                uploader.isLoading && uploader.uploadingName === "rightImage45"
              }
              onChange={(e) =>
                upload(e).then((res) => {
                  rightImage.onChange(res?.uploadedFileFullPath);
                  onRightUploadSuccess();
                })
              }
              onRemove={() => rightImage.onChange(null)}
              defaultImage={defaultImage}
            />
          </div>
        </div>
      )}
    </div>
  );
}

Images45.propTypes = {
  procedureImage: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  leftImage: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  rightImage: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  isLoading: PropTypes.bool,
  procedureArea: PropTypes.string,
};
